// Select all product quantity fields
const productQtyFields = document.querySelectorAll('.product-qty-field');
const mainProductPriceWrappers = document.querySelectorAll('.product-page__price .price-regular');

// Select product volume pricing table rows
const productBssVolumeTableRows = document.getElementsByClassName('bss-b2b-qty-table-row');

formatPrice = function (price) {
  // Remove any non-numeric characters except for commas and periods
  const cleanedPrice = price.replace(/[^0-9.,]/g, '');

  // Replace the comma with a period if necessary for numeric conversion
  const numericPrice = cleanedPrice.replace(',', '.');

  return parseFloat(numericPrice);
}

const initialProductPrice = formatPrice(document.querySelector('.product-page__price .price-regular .price-item').textContent);

// Function to get the appropriate price tier based on quantity
function getPriceTier(quantity, sortedRows) {
  for (let row of sortedRows) {
    const minQuantity = Number(row.getAttribute('data-min'));
    let volumeProductPrice = null;

    Array.from(row.children).forEach(td => {
      if (td.textContent.includes('€')) {
        volumeProductPrice = td.textContent.trim();
      }
    });

    if (quantity >= minQuantity && volumeProductPrice) {
      return { minQuantity, price: volumeProductPrice };
    }
  }
  return null;
}

// Function to apply volume pricing to price wrappers
function applyVolumePricing(priceWrappers, tier) {
  if (tier) {
    priceWrappers.forEach(wrapper => {
      const volumePricingElem = document.createElement('span');
      volumePricingElem.className = 'price-item price-volume-pricing';
      volumePricingElem.textContent = tier.price;
      wrapper.appendChild(volumePricingElem);
    });
  }
}

// Function to check quantity against volume pricing
function checkVolumePrice(event) {
  // Sort rows by minQuantity in descending order
  const allRows = Array.from(productBssVolumeTableRows);
  const sortedRows = allRows.sort((a, b) => {
    return Number(b.getAttribute('data-min')) - Number(a.getAttribute('data-min'));
  });

  // Handle bundle pricing
  const bundleQtyField = event?.target?.closest('.product-bundle__total')?.querySelector('.bundle-qty-box');
  if (bundleQtyField) {
    const bundleContainer = bundleQtyField.closest('.product-bundle__container');
    const bundleQuantity = Number(bundleQtyField.value);
    const bundlePriceWrappers = bundleContainer.querySelectorAll('.price-regular');

    // Remove existing volume pricing
    bundleContainer.querySelectorAll('.price-volume-pricing').forEach(elem => elem.remove());

    // Get and apply new pricing tier
    const bundleTier = getPriceTier(bundleQuantity, sortedRows);
    applyVolumePricing(bundlePriceWrappers, bundleTier);
  } else {
    // Handle main product pricing
    const mainProductQtyField = document.querySelector('.product-qty-field');
    const mainProductQuantity = mainProductQtyField ? Number(mainProductQtyField.value) : 0;

    // Remove existing volume pricing
    document.querySelector('.product-page__price')?.querySelectorAll('.price-volume-pricing').forEach(elem => elem.remove());

    // Get and apply new pricing tier
    const mainProductTier = getPriceTier(mainProductQuantity, sortedRows);
    applyVolumePricing(mainProductPriceWrappers, mainProductTier);
  }
}

// Add event listeners to all quantity fields
productQtyFields.forEach(field => {
  field.addEventListener('input', checkVolumePrice);
});

// Add event listeners for bundle quantity fields
document.querySelectorAll('.product-bundle__total .bundle-qty-box').forEach(field => {
  field.addEventListener('input', checkVolumePrice);
});

// Default check
checkVolumePrice();

setTimeout(() => {
  // The price now updates on quantity input, but clicking a row doesn't trigger an event
  Array.from(productBssVolumeTableRows).forEach(row => {
    row.addEventListener('click', function () {
      productQtyFields.forEach(field => {
        field.dispatchEvent(new Event('input', { bubbles: true }));
      });
      document.querySelectorAll('.product-bundle__total .bundle-qty-box').forEach(field => {
        field.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  });
}, 2000);